import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { Providers } from './providers';

import '../global.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
    ,
  </React.StrictMode>,
);
